// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"NitroCellRenderer_tooltip__hdbY6"};